import TransferList, { TransferListCategoryOption } from 'src/components/TransferList';
import useViewDepartments from 'src/hooks/useViewDepartments';

export const categories: TransferListCategoryOption[] = [
  { value: 0, label: 'Show All', filters: [] },
  {
    value: 1,
    label: 'Show Active/Inactive',
    filters: [{ operator: 'neq', field: 'isDeleted', value: true }],
  },
  {
    value: 2,
    label: 'Show Deleted',
    filters: [{ operator: 'eq', field: 'isDeleted', value: true }],
  },
];

const AssignGlCodes = () => {
  const {
    unassignedGlCodes,
    setUnassignedGlCodes,
    assignedGlCodes,
    setAssignedGlCodes,
    bulkAssignRefresher,
  } = useViewDepartments();

  return (
    <TransferList
      leftList={unassignedGlCodes}
      rightList={assignedGlCodes}
      title="GL Codes"
      leftListTitle="Unassigned GL Codes"
      rightListTitle="Assigned GL Codes"
      searchPlaceholder="Filter by code or description..."
      setLeftList={setUnassignedGlCodes}
      setRightList={setAssignedGlCodes}
      height="calc(100vh - 280px)"
      categories={categories}
      label="GL Code(s)"
      deletedItemLabel="(deleted)"
      bulkAssignRefresher={bulkAssignRefresher}
    />
  );
};

export default AssignGlCodes;
